import { Send, Loader2, Save, PhoneOutgoing } from "lucide-react";
import { Button } from "@/components/ui/button";

// Bottom-right action row: Save · Place Outbound Call · Send inquiry.
export const InquiryFormActions = ({ canSave, saving, onSave, canCall, calling, callHint, onCall, canSend, sending, editingId }) => (
  <div className="flex flex-col sm:flex-row sm:items-center sm:justify-end gap-3 pt-2 border-t border-border" data-testid="inquiry-actions">
    {callHint && (
      <p className="text-[11px] text-muted-foreground sm:mr-auto" data-testid="call-hint">{callHint}</p>
    )}
    <Button type="button" variant="outline" onClick={onSave} disabled={!canSave || saving} data-testid="inquiry-save-btn"
      className="rounded-sm border-border gap-2 font-semibold">
      {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />}
      {saving ? "Saving…" : editingId ? "Save changes" : "Save"}
    </Button>
    <Button type="button" onClick={onCall} disabled={!canCall || calling} data-testid="inquiry-call-btn"
      className="rounded-sm bg-[#34C759] hover:bg-[#2db24d] text-black font-semibold gap-2 disabled:opacity-40">
      {calling ? <Loader2 className="w-4 h-4 animate-spin" /> : <PhoneOutgoing className="w-4 h-4" />}
      {calling ? "Placing call…" : "Place Outbound Call"}
    </Button>
    <Button type="submit" disabled={!canSend || sending} data-testid="inquiry-send-btn"
      className="rounded-sm bg-[#007AFF] hover:bg-[#0066d6] text-white font-semibold gap-2 disabled:opacity-40">
      {sending ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}
      {sending ? "Sending…" : "Send inquiry"}
    </Button>
  </div>
);
